module.exports = __webpack_public_path__ + "static/media/IMG_0527.447d7ea6.jpg";